import { ROLES } from '@/shared/constants/roles';
import { AI_PACKAGE_FEATURE_KEYS, AI_PACKAGE_FLAGS } from '@/shared/constants/packageFeatures';

export const adminRoutes = [
  {
    path: '',
    name: 'dashboard',
    component: () => import('./views/DashboardView.vue'),
    meta: { requiredRole: ROLES.STUDENT },
  },
  {
    path: 'prompts',
    name: 'prompts',
    component: () => import('./views/PromptsView.vue'),
    meta: {
      requiredRole: ROLES.INSTITUTION_ADMIN,
      requiredFeature: AI_PACKAGE_FEATURE_KEYS.PROMPT_LIBRARY,
      requiredFeatureFlag: AI_PACKAGE_FLAGS.viewPromptLibrary,
    },
  },
  {
    path: 'guardrails',
    name: 'guardrails',
    component: () => import('./views/GuardrailsView.vue'),
    meta: { requiredRole: ROLES.SUPER_ADMIN },
  },
  {
    path: 'llm-management',
    name: 'llm-management',
    component: () => import('./views/LLMManagementView.vue'),
    meta: {
      requiredRole: ROLES.INSTITUTION_ADMIN,
      requiredFeature: AI_PACKAGE_FEATURE_KEYS.ALLOW_SWITCH_MODELS,
    },
  },
  {
    path: 'utilities',
    component: () => import('./components/utilities/UtilityLayout.vue'),
    meta: { requiredRole: ROLES.INSTRUCTOR },
    children: [
      {
        path: '',
        redirect: { name: 'curated-course' },
      },
      {
        path: 'curated-course',
        name: 'curated-course',
        component: () => import('./views/ExtendedCourseView.vue'),
        meta: {
          requiredRole: ROLES.INSTRUCTOR,
          requiredFeature: AI_PACKAGE_FEATURE_KEYS.COURSE_COMPETENCY_TOOLS,
          requiredFeatureFlag: AI_PACKAGE_FLAGS.generateCourseContent,
        },
      },
      {
        path: 'competency-tree',
        name: 'competency-tree',
        component: () => import('./views/CompetencyTreeView.vue'),
        meta: {
          requiredRole: ROLES.INSTRUCTOR,
          requiredFeature: AI_PACKAGE_FEATURE_KEYS.COURSE_COMPETENCY_TOOLS,
          requiredFeatureFlag: AI_PACKAGE_FLAGS.createNewCompetencyTree,
        },
      },
      {
        path: 'math-validation',
        name: 'math-validation',
        component: () => import('./views/MathValidationView.vue'),
        meta: { requiredRole: ROLES.INSTRUCTOR },
      },
      {
        path: 'new-tree',
        name: 'new-tree',
        component: () => import('./views/NewTreeView.vue'),
        meta: {
          requiredRole: ROLES.SUPER_ADMIN,
          requiredFeature: AI_PACKAGE_FEATURE_KEYS.COURSE_COMPETENCY_TOOLS,
          requiredFeatureFlag: AI_PACKAGE_FLAGS.createNewCompetencyTree,
        },
      },
      {
        path: 're-indexing',
        name: 're-indexing',
        component: () => import('./views/ReIndexingView.vue'),
        meta: { requiredRole: ROLES.SUPER_ADMIN },
      },
      {
        path: 'lti-creation',
        name: 'lti-creation',
        component: () => import('./views/LTICreationView.vue'),
        meta: { requiredRole: ROLES.SUPER_ADMIN },
      },
      {
        path: 'email-report',
        name: 'email-report',
        component: () => import('./views/EmailReportView.vue'),
        meta: { requiredRole: ROLES.SUPER_ADMIN },
      },
      {
        path: 'update-content-uri',
        name: 'update-content-uri',
        component: () => import('./views/UpdateContentUriView.vue'),
        meta: { requiredRole: ROLES.INSTITUTION_ADMIN },
      },
      {
        path: 'get-course-csv',
        name: 'get-course-csv',
        component: () => import('./views/GetCourseCsvView.vue'),
        meta: { requiredRole: ROLES.INSTITUTION_ADMIN },
      },
    ],
  },
];
